import { Resident, User } from '@lmc/ts-common'
import { FilterValues } from 'screens/Reports/MonitoringReports/components/MonitoringReport/MonitoringReport'
import BasicFilters, {
  DatePickerType,
} from 'screens/Reports/MonitoringReports/components/DashboardFilters/BasicFilters'
import { ReactNode, forwardRef } from 'react'
import { SelectVariant } from '@lmc/ui-kit/src/dataEntry/MultiSelect/MultiSelect'
import {
  Filter,
  SelectedFilters,
} from 'screens/Reports/MonitoringReports/components/DashboardFilters/SelectedFilters'
import { CategoryFilters } from './CategoryFilters'

export type FiltersProps = {
  value: FilterValues
  onChange: (value: FilterValues) => void
  reportingId?: string
  withLoggedBy?: boolean
  hasResidentsFilter?: boolean
  itemsPlaceholder?: string
  itemsCategoryFilter?: string
  children?: ReactNode
  allowClearDateRange?: boolean
  variant?: SelectVariant
  selectedFilters?: Filter
  hasSingleResident?: boolean
  picker?: DatePickerType
}

export const getName = (item: Resident | User) =>
  `${item.name.first} ${item.name.last}`

export const DashboardFilters = forwardRef<HTMLDivElement, FiltersProps>(
  (
    {
      value,
      onChange,
      reportingId,
      withLoggedBy,
      hasResidentsFilter,
      itemsPlaceholder,
      itemsCategoryFilter,
      children,
      allowClearDateRange,
      variant = 'default',
      selectedFilters,
      hasSingleResident,
      picker,
    },
    ref
  ) => {
    const handleInputChange = (newValue: Partial<FilterValues>) => {
      const updatedValue: FilterValues = {
        ...value,
        ...newValue,
      }
      onChange(updatedValue)
    }

    return (
      <>
        <BasicFilters
          value={value}
          onChange={handleInputChange}
          withLoggedBy={withLoggedBy}
          hasResidentsFilter={hasResidentsFilter}
          allowClearDateRange={allowClearDateRange}
          variant={variant}
          hasSingleResident={hasSingleResident}
          picker={picker}
        >
          <CategoryFilters
            value={value}
            reportingId={reportingId}
            itemsPlaceholder={itemsPlaceholder}
            itemsCategoryFilter={itemsCategoryFilter}
            variant={variant}
            onChange={handleInputChange}
          />
          {children}
        </BasicFilters>
        {selectedFilters && (
          <div ref={ref}>
            <SelectedFilters selectedFilters={selectedFilters} />
          </div>
        )}
      </>
    )
  }
)
export default DashboardFilters
